export default {
    quadrant: {
        summary: {
            allZero: 'all values: 0.000',
            allActive: 'all {count} active',
            someActive: '{active} of {total} bins active',
        },
    },
}
